import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  private _newDriverAge = new BehaviorSubject<Date>(null);
  readonly newDriverAge = this._newDriverAge.asObservable();
  private dataStore: { newDriverAge: Date } = { newDriverAge: null };

  constructor() { }

  updateDriverAge(date) {
    this.dataStore.newDriverAge = date;
    this._newDriverAge.next(Object.assign({}, this.dataStore).newDriverAge);

  }

  calculateAgeFromBirthdate(birthday) { // birthday is a date
    let birthDate=new Date(birthday);
    var ageDifMs = Date.now() - birthDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }


}
